'use client';

// Measure the host, per the chart rule (packages/charts/README.md): a viewBox
// guessed at a fixed width and stretched with `w-full` letterboxes itself down
// to that width in the middle of the container, which is what the first draft
// of the pre-upsell chart actually did.
import { useEffect, useState } from 'react';

export function useHostWidth(): [(el: HTMLDivElement | null) => void, number] {
  const [width, setWidth] = useState(0);
  const [node, setNode] = useState<HTMLDivElement | null>(null);
  useEffect(() => {
    if (!node) return;
    // observe() fires once with the current box, so there is no need to seed
    // the width synchronously (and doing so trips the cascading-render lint).
    const ro = new ResizeObserver(([e]) => setWidth(e.contentRect.width));
    ro.observe(node);
    return () => ro.disconnect();
  }, [node]);
  return [setNode, width];
}
